import CartovistaExtend from './js/CartoVistaExtend.js';
import AuthSession from "./js/appTools/AuthSession";
import { show, get } from "./js/appTools/Alerts";
import { exportToPDF } from "./js/appTools/Print";
import DownloadShapefile from "./js/appTools/DownloadShapefile";
import SearchableTreeView from "./js/appTools/SearchableTreeView";
import ZoomLayeringServer from "./js/layers/ZoomLayeringServer";
import ZoomLayeringLocal from "./js/layers/ZoomLayeringLocal";
import ClusterAlgorithmExtend from "./js/layers/ClusterAlgorithmExtend";
import ClustersZoom from "./js/mapTools/ClustersZoom";
import SaveSelection from "./js/mapTools/SaveSelection";
import MapTarget from "./js/mapTools/MapTarget";
import InfoModal from "./js/mapTools/InfoModal";
import MasterBtnThemeSetList from "./js/mapTools/MasterBtnThemeSetList.js";
import Forage from "./js/mapTools/Forage.js";
import ReloadDataTool from "./js/mapTools/ReloadDataTool.js";
import SelectionStats from "./js/mapTools/SelectionStats";
import DrawingControllerExtend from "./js/mapTools/DrawingControllerExtend";
import Constat from "./js/panels/Constat";
import Filter from "./js/panels/Filter";
import QueryCpAdrs from "./js/panels/QueryCpAdrs";
import ServiceAreas from "./js/panels/na/ServiceAreas";
import FindRoutes from "./js/panels/na/FindRoutes";
import BbGraphs from "./js/panels/BbGraphs";
import DecoupagePanel from "./js/panels/DecoupagePanel";
import DescriptionPanel from "./js/panels/DescriptionPanel.js";
import ServiceAreasResultsList from "./js/panels/na/ServiceAreasResultsList";
import ServiceAreasResultItem from "./js/panels/na/ServiceAreasResultItem";
import FeatureItem from "./js/panels/Results/FeatureItem";
import Flow from "./js/panels/flow/Flow.js";
import {updateColumnsWithStoreValues} from "./js/stores/LayersUpdater";
import { findRoutes, contactUs, queryLayer, queryStore, updateSectors, addSectors, deleteSectors } from "./js/utils/ServerRequests";
import { createLayer, createFeatures, createDataRows, createThemeSetElement, _loadLayersData, _loadEsriLayersData, _loadCartovistaLayersData, joinDataTable} from "./js/utils/CvUtils";


//assets
import "./images/icones/collegial/collegial_public.png";
import "./images/icones/collegial/collegial_public_hover.png";
import "./images/icones/collegial/collegial_prive.png";
import "./images/icones/collegial/collegial_prive_hover.png";
import "./images/icones/collegial/collegial_gouv.png";
import "./images/icones/collegial/collegial_gouv_hover.png";
import "./images/icones/collegial/collegial_cctt.png";
import "./images/icones/collegial/collegial_cec.png";
import "./images/icones/gouvernemental/gouvernemental.png";
import "./images/icones/gouvernemental/gouvernemental_hover.png";
import "./images/icones/prive/prive_presco.png";
import "./images/icones/prive/prive_presco_hover.png";
import "./images/icones/prive/prive_prim.png";
import "./images/icones/prive/prive_prim_hover.png";
import "./images/icones/prive/prive_sec.png";
import "./images/icones/prive/prive_sec_hover.png";
import "./images/icones/prive/prive_presco_prim.png";
import "./images/icones/prive/prive_presco_prim_hover.png";
import "./images/icones/prive/prive_presco_prim_sec.png";
import "./images/icones/prive/prive_presco_prim_sec_hover.png";
import "./images/icones/prive/prive_presco_sec.png";
import "./images/icones/prive/prive_presco_sec_hover.png";
import "./images/icones/prive/prive_prim_sec.png";
import "./images/icones/prive/prive_prim_sec_hover.png";
import "./images/icones/prive/prive_form_prof.png";
import "./images/icones/prive/prive_form_prof_hover.png";
import "./images/icones/prive/prive_adulte.png";
import "./images/icones/prive/prive_adulte_hover.png";
import "./images/icones/universitaire/universitaire.png";
import "./images/icones/universitaire/universitaire_hover.png";
import "./images/icones/universitaire/universitaire.png";
import "./images/icones/public/public_presco_anglo.png";
import "./images/icones/public/public_presco_anglo_hover.png";
import "./images/icones/public/public_prim_anglo.png";
import "./images/icones/public/public_prim_anglo_hover.png";
import "./images/icones/public/public_sec_anglo.png";
import "./images/icones/public/public_sec_anglo_hover.png";
import "./images/icones/public/public_presco_prim_anglo.png";
import "./images/icones/public/public_presco_prim_anglo_hover.png";
import "./images/icones/public/public_presco_prim_sec_anglo.png";
import "./images/icones/public/public_presco_prim_sec_anglo_hover.png";
import "./images/icones/public/public_presco_sec_anglo.png";
import "./images/icones/public/public_presco_sec_anglo_hover.png";
import "./images/icones/public/public_prim_sec_anglo.png";
import "./images/icones/public/public_prim_sec_anglo_hover.png";
import "./images/icones/public/public_form_prof_anglo.png";
import "./images/icones/public/public_form_prof_anglo_hover.png";
import "./images/icones/public/public_adulte_anglo.png";
import "./images/icones/public/public_adulte_anglo_hover.png";
import "./images/icones/public/public_presco_franco.png";
import "./images/icones/public/public_presco_franco_hover.png";
import "./images/icones/public/public_prim_franco.png";
import "./images/icones/public/public_prim_franco_hover.png";
import "./images/icones/public/public_sec_franco.png";
import "./images/icones/public/public_sec_franco_hover.png";
import "./images/icones/public/public_presco_prim_franco.png";
import "./images/icones/public/public_presco_prim_franco_hover.png";
import "./images/icones/public/public_presco_prim_sec_franco.png";
import "./images/icones/public/public_presco_prim_sec_franco_hover.png";
import "./images/icones/public/public_presco_sec_franco.png";
import "./images/icones/public/public_presco_sec_franco_hover.png";
import "./images/icones/public/public_prim_sec_franco.png";
import "./images/icones/public/public_prim_sec_franco_hover.png";
import "./images/icones/public/public_form_prof_franco.png";
import "./images/icones/public/public_form_prof_franco_hover.png";
import "./images/icones/public/public_adulte_franco.png";
import "./images/icones/public/public_adulte_franco_hover.png";
import "./images/icones/public/public_presco_statut.png";
import "./images/icones/public/public_presco_statut_hover.png";
import "./images/icones/public/public_prim_statut.png";
import "./images/icones/public/public_prim_statut_hover.png";
import "./images/icones/public/public_sec_statut.png";
import "./images/icones/public/public_sec_statut_hover.png";
import "./images/icones/public/public_presco_prim_statut.png";
import "./images/icones/public/public_presco_prim_statut_hover.png";
import "./images/icones/public/public_presco_prim_sec_statut.png";
import "./images/icones/public/public_presco_prim_sec_statut_hover.png";
import "./images/icones/public/public_presco_sec_statut.png";
import "./images/icones/public/public_presco_sec_statut_hover.png";
import "./images/icones/public/public_prim_sec_statut.png";
import "./images/icones/public/public_prim_sec_statut_hover.png";
import "./images/icones/public/public_form_prof_statut.png";
import "./images/icones/public/public_form_prof_statut_hover.png";
import "./images/icones/public/public_adulte_statut.png";
import "./images/icones/public/public_adulte_statut_hover.png";
import "./images/icones/public/immeubles/public_prim_anglo.png";
import "./images/icones/public/immeubles/public_prim_anglo_hover.png";
import "./images/icones/public/immeubles/public_prim_sec_anglo.png";
import "./images/icones/public/immeubles/public_prim_sec_anglo_hover.png";
import "./images/icones/public/immeubles/public_sec_anglo.png";
import "./images/icones/public/immeubles/public_sec_anglo_hover.png";
import "./images/icones/public/immeubles/public_form_prof_anglo.png";
import "./images/icones/public/immeubles/public_form_prof_anglo_hover.png";
import "./images/icones/public/public_autre_anglo.png";
import "./images/icones/public/public_autre_anglo_hover.png";
import "./images/icones/public/immeubles/public_prim_franco.png";
import "./images/icones/public/immeubles/public_prim_franco_hover.png";
import "./images/icones/public/immeubles/public_prim_sec_franco.png";
import "./images/icones/public/immeubles/public_prim_sec_franco_hover.png";
import "./images/icones/public/immeubles/public_sec_franco.png";
import "./images/icones/public/immeubles/public_sec_franco_hover.png";
import "./images/icones/public/immeubles/public_form_prof_franco.png";
import "./images/icones/public/immeubles/public_form_prof_franco_hover.png";
import "./images/icones/public/public_autre_franco.png";
import "./images/icones/public/public_autre_franco_hover.png";
import "./images/icones/public/immeubles/public_prim_statut.png";
import "./images/icones/public/immeubles/public_prim_statut_hover.png";
import "./images/icones/public/immeubles/public_prim_sec_statut.png";
import "./images/icones/public/immeubles/public_prim_sec_statut_hover.png";
import "./images/icones/public/immeubles/public_sec_statut.png";
import "./images/icones/public/immeubles/public_sec_statut_hover.png";
import "./images/icones/public/immeubles/public_form_prof_statut.png";
import "./images/icones/public/immeubles/public_form_prof_statut_hover.png";
import "./images/icones/public/public_autre_statut.png";
import "./images/icones/public/public_autre_statut_hover.png";
import "./images/icones/loisir_sport/sport_etudes.png";
import "./images/icones/loisir_sport/sport_etudes_hover.png";
import "./images/icones/mat4ans/prive_prim_mat4.png";
import "./images/icones/mat4ans/prive_prim_mat4_hover.png";
import "./images/icones/mat4ans/prive_prim.png";
import "./images/icones/mat4ans/prive_prim_hover.png";
import "./images/icones/mat4ans/public_prim_anglo_mat4.png";
import "./images/icones/mat4ans/public_prim_anglo_mat4_hover.png";
import "./images/icones/mat4ans/public_prim_anglo.png";
import "./images/icones/mat4ans/public_prim_anglo_hover.png";
import "./images/icones/mat4ans/public_prim_franco_mat4.png";
import "./images/icones/mat4ans/public_prim_franco_mat4_hover.png";
import "./images/icones/mat4ans/public_prim_franco.png";
import "./images/icones/mat4ans/public_prim_franco_hover.png";
import "./images/icones/mat4ans/public_prim_statut_mat4.png";
import "./images/icones/mat4ans/public_prim_statut_mat4_hover.png";
import "./images/icones/mat4ans/public_prim_statut.png";
import "./images/icones/mat4ans/public_prim_statut_hover.png";
import "./images/icones/aide_alimentaire/plusieurs_organismes.png";
import "./images/icones/aide_alimentaire/plusieurs_organismes_hover.png";
import "./images/icones/aide_alimentaire/tablee_des_chefs.png";
import "./images/icones/aide_alimentaire/tablee_des_chefs_hover.png";
import "./images/icones/aide_alimentaire/cantine_pour_tous.png";
import "./images/icones/aide_alimentaire/cantine_pour_tous_hover.png";
import "./images/icones/aide_alimentaire/club_petits_dejeuners.png";
import "./images/icones/aide_alimentaire/club_petits_dejeuners_hover.png";
import "./images/pdf-icon.png";
import "./images/logos/QUEBEC_blanc.svg";
import "./images/logos/preloaderMEES.gif";
import "./images/loader-transparent.gif";
import "./images/favicon.png";


export { CartovistaExtend, AuthSession, ClustersZoom, SaveSelection, Constat, ServiceAreas, FindRoutes, MapTarget, contactUs, show, ZoomLayeringServer,
  InfoModal, get, exportToPDF, queryStore, ServiceAreasResultsList, ServiceAreasResultItem, FeatureItem, 
  createLayer, createThemeSetElement, updateSectors, addSectors, deleteSectors, _loadLayersData, _loadEsriLayersData, _loadCartovistaLayersData,
  DecoupagePanel, SelectionStats, DrawingControllerExtend, DescriptionPanel,
  ReloadDataTool, queryLayer, createFeatures, createDataRows, DownloadShapefile,
  QueryCpAdrs, ClusterAlgorithmExtend, SearchableTreeView, findRoutes, ZoomLayeringLocal,
  Forage, MasterBtnThemeSetList, BbGraphs, joinDataTable, Flow,
  updateColumnsWithStoreValues, Filter
}